/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "./styles/sign-in-up.css";
import { useNavigate } from "react-router-dom";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import Axios from "../api/Axios";
import MloginIcon from "../assets/icons/ms-symbollockup_mssymbol_19.png";
import {
  EyeTwoTone,
  EyeInvisibleOutlined,
  LoadingOutlined,
  LoginOutlined,
  ForwardOutlined,
  ExclamationCircleTwoTone,
} from "@ant-design/icons";
import {
  message,
  Form,
  Input,
  Button,
  Row,
  Col,
  Divider,
  Spin,
  Popconfirm,
  Modal,
} from "antd";
import {
  // EMPLOYEE_EARLY_LOGIN,
  REDIRECT_COACHING,
  REDIRECT_LEARNING,
  MIGRATION_REDIRECT_URL,
} from "../config";
import { useDispatch } from "react-redux";
import { userData } from "../store/slices/UserInfo";
import { setmessageSlice } from "../store/slices/messageSlice";
import { allowedRoles } from "../components/icons/ApplicationColor";
import ImagesSlider from "../components/ImagesSlider";
import MaintenanceModal from "../components/AdminComponents/Modals/MaintenanceModal";
import LocationAccess from "../components/LocationAccess";
import dayjs from "dayjs";
import { setClientData } from "../store/slices/OrgDetail";
import { useSelector } from "react-redux";
import LoginAxios from "../api/LoginAxios";
import { resetNotifications } from "../store/slices/notificationSlice";
import { MAIN_LOGO_BIG } from "../ImagesSrc";
const Newsignin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [showUserID, setShowUserID] = useState(false);
  const [multipleUsers, setMultipleUsers] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const dispatch = useDispatch();
  const [isEmail, setIsEmail] = useState(false);
  const [isEmailSecond, setIsEmailSecond] = useState(false);
  const [loading, setLoading] = useState(false);
  const [microsoftLoader, setMicrosoftLoader] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const notExists = (msg) => {
    messageApi.open({
      type: "warning",
      content: msg,
      duration: 5,
    });
  };

  const routeToPass = () => {
    dispatch(setmessageSlice(true));
  };
  const WrongPassword = (text) => {
    const textDis =
      text === "Incorrect password." ? "Please enter a valid password" : text;
    messageApi.open({
      type: "error",
      content: textDis,
      duration: 7,
    });
  };

  const history = useNavigate();

  const handleMigration = (isMigrated, migrationDate) => {
    const currentDate = dayjs().format("YYYY-MM-DD");
    const formattedMigrationDate = migrationDate
      ? migrationDate.split("T")[0]
      : null;
    if (
      isMigrated &&
      formattedMigrationDate &&
      formattedMigrationDate <= currentDate
    ) {
      Modal.confirm({
        title: "Migration Notice",
        content: (
          <span>
            Your organization has been successfully migrated to our next-gen
            platform, <span style={{ color: "#1266a0" }}><b>Trainery</b></span>
            <span style={{ color: "#d55b49" }}><b>HCM</b></span>.<br/><br/>
            Please click <b>OK</b> to continue
          </span>
        ),
        okText: "OK",
        cancelButtonProps: { style: { display: "none" } },
        maskClosable: false,
        keyboard: false,
        onOk: () => {
          window.location.replace(MIGRATION_REDIRECT_URL);
        },
      });
      return true;
    }
    return false;
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      history("/home");
    }
    dispatch(resetNotifications());
  }, [history]);

  const redirectUser = async () => {
    try {
      const res = await Axios.get("/auth-user/");
      setLoading(false);
      dispatch(userData(res.data));

      const isAdmin = res.data?.roles?.some((role) =>
        allowedRoles.includes(role.key_name)
      );
      isAdmin
        ? localStorage.setItem("isAdmin", "true")
        : localStorage.removeItem("isAdmin");

      setMicrosoftLoader(false);

      const { custom_notification, default_application } = res.data;

      if (custom_notification?.custom_notification_exists) {
        if (custom_notification.mandatory_read) {
          history("/home?redirect=true");
          return;
        }
      }

      const proceedWithRedirect = () => {
        if (default_application?.name) {
          switch (default_application.name) {
            case "Trak Learning":
              window.location.href = REDIRECT_LEARNING;
              break;
            case "Trak Coaching":
              window.location.href = REDIRECT_COACHING;
              break;
            default:
              window.location.href = default_application.url;
          }
        } else {
          history("/home");
        }
      };

      if (
        handleMigration(
          res.data?.organization?.is_migrated,
          res.data?.organization?.migration_date
        )
      ) {
        // Redirection will be handled by handleMigration Modal
      } else {
        proceedWithRedirect();
      }
    } catch (err) {
      setLoading(false);
      localStorage.removeItem("token");
      localStorage.clear();
      history("/");
    }
  };

  useEffect(() => {
    const inputField = document.getElementById("inputFieldId");
    if (inputField) {
      inputField.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
        }
      });
    }
    localStorage.removeItem("OtpSent");
  }, []);
  const handleNext3 = async () => {
    //console.log(isEmail);
    try {
      await form.validateFields();
      const response = await Axios.get("/usercheck/", {
        params: { search: form.getFieldValue("emailAndUserId") },
      });

      //console.log(response.data);

      const {
        exists,
        multiple_users,
        email,
        user_id,
        message,
        route_to_reset_password,
        is_migrated,
        migration_date,
      } = response.data;

      if (!exists) {
        notExists(message);
      } else {
        if (handleMigration(is_migrated, migration_date)) {
          setLoading(false);
          return;
        }
        if (route_to_reset_password) {
          const { token, uid } = response.data;
          routeToPass();

          history(`/setpassword/${uid}/${token}`);
        } else {
          if (multiple_users) {
            setMultipleUsers(multiple_users);
          } else {
            setShowEmail(email);
            setShowUserID(user_id);
            setShowPassword(true);
          }
        }
      }
      setLoading(false);
    } catch (errorInfo) {
      //console.log("Validation failed:", errorInfo);
      setLoading(false);
    }
  };
  const ReloginAfterCsrfError = async (payload) => {
    try {
      const res = await LoginAxios.post("/login/", payload);
      //console.log(res.data);
      localStorage.setItem("token", res.data.token);
      redirectUser(res);
    } catch (err) {
      //console.log(err?.response?.data?.detail);

      WrongPassword(err?.response?.data?.detail);
      setLoading(false);
    }
  };
  const CsrfErrorHandel = async (payload) => {
    try {
      await LoginAxios.get("/logout/");
      localStorage.clear();
      //console.log(res);
      ReloginAfterCsrfError(payload);
    } catch (err) {
      if (err.response.status === 403 || err.response.status === 401) {
        localStorage.clear();
        ReloginAfterCsrfError(payload);
      }
    }
  };
  const handleNext4 = async () => {
    //console.log(isEmailSecond);
    try {
      await form.validateFields();
      if (isEmailSecond) {
        const response = await Axios.get(
          `/usercheck/?search=${form.getFieldValue(
            "emailAndUserId"
          )}&email=${form.getFieldValue("clientIdOrEmail")}`
        );

        //console.log(response.data);

        const {
          exists,
          message,
          email,
          user_id,
          route_to_reset_password,
          is_migrated,
          migration_date,
        } = response.data;

        if (!exists) {
          notExists(message);
        } else {
          if (handleMigration(is_migrated, migration_date)) {
            setLoading(false);
            return;
          }
          if (route_to_reset_password) {
            const { token, uid } = response.data;
            routeToPass();
            history(`/setpassword/${uid}/${token}`);
          } else {
            setShowEmail(email);
            setShowUserID(user_id);
            setShowPassword(true);
          }
        }
      } else {
        const response = await Axios.get(
          `/usercheck/?search=${form.getFieldValue(
            "emailAndUserId"
          )}&client_id=${form.getFieldValue("clientIdOrEmail")}`
        );

        //console.log(response.data);

        const {
          exists,
          email,
          message,
          user_id,
          route_to_reset_password,
          is_migrated,
          migration_date,
        } = response.data;

        if (!exists) {
          notExists(message);
        } else {
          if (handleMigration(is_migrated, migration_date)) {
            setLoading(false);
            return;
          }
          if (route_to_reset_password) {
            const { token, uid } = response.data;
            routeToPass();
            history(`/setpassword/${uid}/${token}`);
          } else {
            setShowEmail(email);
            setShowUserID(user_id);
            setShowPassword(true);
          }
        }
        //console.log(showPassword);
      }
      setLoading(false);
    } catch (errorInfo) {
      //console.log("Validation failed:", errorInfo);
      setLoading(false);
    }
  };
  const [form] = Form.useForm();
  const signInSubmit = async (values) => {
    //console.log("Form values on submit:", values);
    const payload = {
      email: isEmail
        ? values.emailAndUserId
        : isEmailSecond
        ? values.clientIdOrEmail
        : showEmail
        ? values.email
        : null,
      user_id: !isEmail
        ? values.emailAndUserId
        : showUserID
        ? values.user_id
        : null,
      client_id:
        !isEmailSecond && multipleUsers ? values.clientIdOrEmail : null,
      password: values.password,
      longitude: longitude,
      latitude: latitude,
    };
    try {
      const res = await LoginAxios.post("/login/", payload);
      //console.log(res.data);
      if (res?.data?.location_access) {
        localStorage.setItem("token", res.data.token);
        redirectUser(res);
      } else {
        const { password, ...payloadWithoutPassword } = payload;
        setLoading(false);
        checkLocationPermission(payloadWithoutPassword);
      }
    } catch (err) {
      //console.log(err?.response?.data?.detail);
      if (err?.response?.status === 403) {
        CsrfErrorHandel(payload);
      } else {
        WrongPassword(err?.response?.data?.detail);
        setLoading(false);
      }
    }
    //console.log(payload);
  };
  const { instance, accounts } = useMsal();
  //console.log(accounts, "acc");
  const isAuthenticated = useIsAuthenticated();
  const Microsoftlogin = async () => {
    setMicrosoftLoader(true);
    localStorage.setItem("microsoft-loginClicked", true);
    try {
      await instance.loginRedirect({
        scopes: ["openid", "profile", "User.Read"], // Add the necessary scopes
      });
    } catch (error) {
      console.error("Error during login:", error);
    }
  };
  const MSLogin = async (token) => {
    localStorage.removeItem("microsoft-loginClicked");
    const tokenCheck = localStorage.getItem("token");
    if (!tokenCheck) {
      const payload = {
        microsoft_access_token: token,
      };
      try {
        setMicrosoftLoader(true);
        const res = await Axios.post("/login/", payload);
        //console.log(res.data);
        localStorage.setItem("token", res.data.token);
        redirectUser(res);
      } catch (err) {
        //console.log(err?.response?.data?.detail);
        history("/trainery-ms-login-failed");
        //   WrongPassword(err?.response?.data?.detail);
        //   setLoading(false);
      }
    } else {
      redirectUser(tokenCheck);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (
        isAuthenticated &&
        accounts.length > 0 &&
        localStorage.getItem("microsoft-loginClicked")
      ) {
        const accessTokenRequest = {
          // scopes: ["User.ReadBasic.All"],
          scopes: ["User.Read"],
          account: accounts[0], // Use the first authenticated account
        };

        try {
          const response = await instance.acquireTokenSilent(
            accessTokenRequest
          );
          MSLogin(response.accessToken);
          //console.log("Access Token:", response.accessToken);
        } catch (error) {
          console.error("Access Token:", error);
        }
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, accounts, instance]);
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalClose = () => {
    setModalVisible(false);
  };

  //location access code
  useEffect(() => {
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by your browser");
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);

          // console.log(
          //   `Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}`
          // );
        },
        (error) => {
          //console.log("Unable to retrieve your location");
        }
      );
    }
  }, []);
  const [visible, setVisible] = useState(false);

  const checkLocationPermission = (payload) => {
    navigator.permissions
      .query({ name: "geolocation" })
      .then((result) => {
        if (result.state === "granted") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              // console.log(
              //   `Latitude: ${position.coords.latitude}, Longitude: ${position.coords.longitude}`
              // );
              const locationPayload = {
                ...payload,
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
              };
              dispatch(
                setClientData({
                  loginPayload: locationPayload,
                })
              );
              history("/location-otp-verification");
              setVisible(false);
            },
            (error) => {
              console.error("Error getting location:", error);
            }
          );
        } else {
          requestLocation();
          setVisible(true);
        }
      })
      .catch((error) => {
        console.error("Error checking location permission:", error);
      });
  };

  const handleSuccess = (position) => {
    setVisible(false);
  };

  const handleError = (error) => {
    setVisible(true);
  };

  const requestLocation = () => {
    if (navigator.geolocation) {
      setVisible(true);
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
    } else {
      //console.log("error in location");
    }
  };

  const handleClose = () => {
    setVisible(false);
  };
  const messageSlice = useSelector((state) => state.messageSlice);

  useEffect(() => {
    if (messageSlice) {
      messageApi.open({
        type: "success",
        content: "Verification Success, Kindly login from here",
        duration: 6,
      });

      dispatch(setmessageSlice(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messageSlice, dispatch]);
  const confirm = () => {
    window.open("/help", "_blank"); // Open the help page in a new tab
  };
  return (
    <Spin spinning={microsoftLoader}>
      <LocationAccess visible={visible} handleClose={handleClose} />

      <div className="main-co">
        {contextHolder}
        <div
          className="cont"
          style={{
            height:
              multipleUsers && showPassword
                ? "62rem"
                : (showEmail || showUserID) && showPassword
                ? "58rem"
                : "56rem",
          }}
        >
          <div className="left">
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                alt=""
                src={MAIN_LOGO_BIG}
                className="logo1"
                height="auto"
                width="155px"
              />
            </div>
            <div className="signIn_text1">Sign in</div>
            {multipleUsers && showPassword && showEmail ? null : (
              <div className="text-para1">
                One Trainery account for Everything eLearning and HR Solutions{" "}
                <Popconfirm
                  title="Need help logging in?"
                  description={
                    <span>Click on the link below to visit help page: </span>
                  }
                  onConfirm={confirm}
                  okText="help"
                  cancelText="cancel"
                  trigger="hover"
                >
                  <ExclamationCircleTwoTone
                    className="hover-icon-login"
                    style={{ fontSize: "17px", marginLeft: "5px" }}
                  />
                </Popconfirm>
              </div>
            )}
            <Form
              form={form}
              initialValues={{
                emailAndUserId: "",
                orgId: "",
                user_id: "",
                email: "",
                password: "",
                clientIdOrEmail: "",
              }}
              onFinish={(values) => {
                if (!loading) {
                  form
                    .validateFields()
                    .then(() => {
                      if (!showPassword) {
                        if (multipleUsers) {
                          setLoading(true);
                          handleNext4();
                        } else {
                          setLoading(true);
                          handleNext3();
                        }
                      } else {
                        setLoading(true);
                        signInSubmit(values);
                      }
                    })
                    .catch((errorInfo) => {
                      //console.log("Form validation failed:", errorInfo);
                    });
                }
              }}
            >
              <Row
                gutter={20}
                style={{ marginTop: showPassword ? "2rem" : "3rem" }}
              >
                <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                  <Form.Item
                    name="emailAndUserId"
                    rules={[
                      {
                        required: true,
                        message: "Please enter either user id or email",
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value) {
                            // If empty, only show the "required" error
                            return Promise.reject("");
                          }

                          const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                            value
                          );
                          const isUserId =
                            /^[a-zA-Z0-9!#$%^&*()_+{}\\[\]:;<>,?~ -]+$/g.test(
                              value
                            );

                          setIsEmail(isEmail);

                          if (isEmail || (isUserId && value.length >= 3)) {
                            return Promise.resolve();
                          }

                          return Promise.reject(
                            isUserId
                              ? "User ID must be at least 3 characters."
                              : "Please enter a valid email."
                          );
                        },
                      }),
                    ]}
                  >
                    <Input
                      placeholder="Enter your email or user id"
                      className="input-col1"
                      type="text"
                      id="emailAndUserId"
                      name="emailAndUserId"
                      disabled={showPassword || multipleUsers}
                      style={{
                        backgroundColor:
                          showPassword || multipleUsers ? "#E8F0FE" : "inherit",
                        color: "black",
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {multipleUsers && (
                <Row gutter={20}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item
                      name="clientIdOrEmail"
                      rules={[
                        {
                          required: true,
                          message: "Please enter either client id or email",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject("");
                            }

                            const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                              value
                            );
                            const isClientID =
                              /^[a-zA-Z0-9!#$%^&*()_+{}\\[\]:;<>,?~ -]+$/g.test(
                                value
                              );

                            setIsEmailSecond(isEmail);

                            if (isEmail || (isClientID && value.length >= 2)) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              isClientID
                                ? "Client ID must be at least 2 characters."
                                : "Please enter a valid email."
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        placeholder="Enter your email or client id"
                        className="input-col1"
                        type="text"
                        id="clientIdOrEmail"
                        name="clientIdOrEmail"
                        disabled={showPassword}
                        style={{
                          backgroundColor: showPassword ? "#E8F0FE" : "inherit",
                          color: "black",
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {showEmail && (
                <Row gutter={20}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          required: true,
                          message: "Enter a valid email",
                          type: "email",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter your email"
                        className="input-col1"
                        type="text"
                        id="email"
                        name="email"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {showUserID && (
                <Row gutter={20}>
                  <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                    <Form.Item
                      name="user_id"
                      rules={[
                        {
                          required: true,
                          message: "User ID is required",
                          type: "text",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject("");
                            }

                            const isClientID =
                              /^[a-zA-Z0-9!#$%^&*()_+{}\\[\]:;<>,?~ -]+$/g.test(
                                value
                              );

                            if (isClientID && value.length >= 3) {
                              return Promise.resolve();
                            }

                            return Promise.reject(
                              "User ID must be at least 3 characters."
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        placeholder="Enter your User ID"
                        className="input-col1"
                        type="text"
                        id="user_id"
                        name="user_id"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              {!showPassword && (
                <>
                  <Row gutter={10}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item>
                        <Button
                          className="button-29"
                          // onClick={multipleUsers ? handleNext4 : handleNext3}
                          type="primary"
                          htmlType="submit"
                          style={{
                            marginTop: "0rem",
                            cursor: loading ? "not-allowed" : "pointer",
                          }}
                          disabled={loading}
                        >
                          NEXT
                          {loading ? (
                            <LoadingOutlined />
                          ) : (
                            <ForwardOutlined style={{ fontSize: "18px" }} />
                          )}
                        </Button>
                        {showEmail || showUserID || multipleUsers ? (
                          <div
                            className="forgot-text1"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              history("/forgot-password");
                            }}
                          >
                            Forgot password?
                          </div>
                        ) : null}
                      </Form.Item>
                    </Col>
                  </Row>
                  {!showEmail && !showUserID && !multipleUsers ? (
                    <>
                      <Row gutter={20}>
                        <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                          <Divider
                            style={{
                              borderColor: "#d9d9d9",
                              paddingLeft: "4rem",
                              paddingTop: "0px",
                              paddingBottom: "0px",
                              margin: "0px",
                            }}
                            plain
                          >
                            <span style={{ color: "gray" }}>OR</span>
                          </Divider>
                        </Col>
                      </Row>
                      <Row gutter={20}>
                        <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                          <Form.Item>
                            <Button
                              className="microsoft-button"
                              onClick={() => {
                                Microsoftlogin();
                              }}
                              type="default"
                            >
                              <img src={MloginIcon} alt="" />
                              <span className="button-text">
                                Sign in with Microsoft
                              </span>
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                </>
              )}
              {showPassword && (
                <>
                  <Row gutter={20}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item
                        name="password"
                        rules={[
                          {
                            required: true,
                            message: "Password is required",
                          },
                          {
                            min: 6,
                            message: "Password must be at least 6 characters",
                          },
                        ]}
                      >
                        <Input.Password
                          placeholder="Password"
                          className="input-col1"
                          type="password"
                          name="password"
                          id="password"
                          iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                          }
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={20} sm={20} md={21} lg={21} xl={21}>
                      <Form.Item>
                        <Button
                          className="button-29"
                          type="primary"
                          htmlType="submit"
                          style={{
                            marginTop: "0rem",
                            cursor: loading ? "not-allowed" : "pointer",
                          }}
                          disabled={loading}
                        >
                          LOGIN
                          {loading ? (
                            <LoadingOutlined />
                          ) : (
                            <LoginOutlined style={{ fontSize: "17px" }} />
                          )}
                        </Button>
                        <div
                          className="forgot-text1"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            history("/forgot-password");
                          }}
                        >
                          Forgot password?
                        </div>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              )}
            </Form>
          </div>
          <ImagesSlider />
        </div>
      </div>
      <MaintenanceModal visible={modalVisible} onClose={handleModalClose} />
    </Spin>
  );
};

export default Newsignin;
